{
    "name": "columnWarningOpacity",
    "duration": 0.5,
    "keyframes": {"/_TintColor.a": [0.5, 0.0]},
    "wrapMode": 4,
    "guid": "dc1fa20f50a844e8a9c8043dab80af56",
    "assetPath": "Assets/Animation/columnWarningOpacity.anim"
}
